import braOption1 from "/public/Images/Option1Bandpullsfar.gif";
import braOption2 from "/public/Images/Option2Bandpullsokay.gif";
import braOption3 from "/public/Images/Option3Bandlooksgood.gif";
import tightestHook from "/public/Images/TightestHook.jpg";

// bf2
export const bf6 = [
  {
    id: 1,
    type: "prompt",
    content:
      "Possibly! I suggest we look into your band size. 80% of the support comes from the band. If the band is too loose, your breasts weight might be distributed incorrectly to your shoulders creating pain. ",
    options: [{ label: "Enter Size", next: 2 }],
    next: 2,
  }, // braSizeInput
  {
    id: 2,
    type: "braSizeInput",
    content: "Enter your current bra size:",
    next: 3,
  },
  {
    id: 3,
    type: "textPromptWithImages",
    content:
      "Thanks for that. Now let’s put the bra on the tightest hooks for me. Make sure to pull the band down so it’s parallel to the front band & adjust your straps, like this GIF below.",
    image: tightestHook,
    option: { label: "I am ready to proceed", next: 4 },
  },
  {
    id: 4,
    type: "promptWithImages",
    content:
      "Now, pull the band away from your body. Which gif below resonates the most?",
    options: [
      {
        label: "Band pulls far",
        image: braOption1,
        next: 5,
      },
      {
        label: "Band pulls okay",
        image: braOption2,
        next: 6,
      },
      {
        label: "Band looks good",
        image: braOption3,
        next: 7,
      },
    ],
  },

  {
    id: 5,
    type: "result",
    content:
      "Going down 2 band sizes should improve the fit and alleviate your shoulder pain. Based on your {initial bra size}, I suggest you try {new bra size}. Here are some options in this size for you:",
    options: [{ label: "[Display Best-Selling Products]" }],
  },
  {
    id: 6,
    type: "result",
    content:
      "Going down 1 band size should improve the fit and alleviate your shoulder pain. Based on your {initial bra size}, I suggest you try {new bra size}. Here are some options in this size for you:",
    options: [{ label: "[Display Best-Selling Products]" }],
  },
  {
    id: 7,
    type: "result",
    content:
      "It appears that your band size is correct. In this case, I suggest that you loosen up the straps a bit. Two fingers should comfortable fit underneath like the gif below. \n Also, if you have uneven breasts, make sure that the straps on the fuller side is proportionally looser than the smaller one.",
    options: [{ label: "[Display Best-Selling Products]" }],
  },
];
